// src/components/AuthNav.jsx
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './AuthNav.css';
// import UserFormModal from './users/UserFormModal';

const AuthNav = () => {

  const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0();

  // Use Auth0 user directly
  const displayUser = user;

  if (isLoading) {
    return <div className="auth-loading">Loading...</div>;
  }

  return (
    <div className="auth-nav">
      {isAuthenticated ? (
        <div className="user-info">
          <span className="user-name">
            Welcome, {displayUser.first_name || displayUser.given_name || displayUser.name || displayUser.email}!
          </span>
          <button 
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            className="logout-button"
          >
            Log Out
          </button>
          <img 
              src={displayUser.picture}
              alt={(displayUser.family_name ? 
                (displayUser.given_name?.[0] || '') + (displayUser.family_name?.[0] || '') : 
                (displayUser.given_name?.[0] || displayUser.email?.[0] || '')).toUpperCase()}
              style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  flexShrink: 0,
                  marginRight: '10px',
                  display: 'grid',
                  placeItems: 'center',
                  cursor: 'pointer',
                  marginLeft: '10px'
              }}/>
        </div>
      ) : (
        <button 
          onClick={() => loginWithRedirect()}
          className="login-button"
        >
          Log In
        </button>
      )}
    </div>
  );
};

export default AuthNav;